import { useEffect } from 'react'

export const useBrowserTab = (props) => {
  const { tabName = 'Xpart' } = props
  useEffect(() => {
    document.title = tabName
  }, [])
}